module.exports = __webpack_public_path__ + "static/media/businessspot.c6e0ff99.svg";